import { Box, IconButton, Typography } from "@mui/material";

import EditIcon from "@/assets/SVG/editIcon";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useMemo, useState } from "react";
import { removePatientFromArea } from "../../../api/group";
import FemaleIcon from "../../../assets/SVG/femaleIcon";
import MaleIcon from "../../../assets/SVG/maleIcon";
import TrashIcon from "../../../assets/SVG/trashIcon";
import DeleteAlertModal from "../../../pages/leaderGroup/deleteAlertModal";
import CustomTable from "../../customTable/CustomTable";

export default function TablePatient({
  setShowEditModal,
  setDataRowEdit,
  rowData,
  areaId,
  setDataPatients,
  totalElements,
  pageable,
  setPageable,
  refetching,
}) {
  const [dataRowDelete, setDataRowDelete] = useState();
  const [deleteModal, setDeleteModal] = useState();
  // Column Definitions: Defines & controls grid columns.
  const handleDelete = () => {
    if (dataRowDelete) {
      removePatientFromArea(areaId, dataRowDelete.id)
        .then(() => {
          setDeleteModal(false);
          setDataPatients(rowData.filter((e) => e.id !== dataRowDelete.id));
        })
        .catch(() => {});
    }
  };

  const [colDefs] = useMemo(
    () => [
      [
        {
          headerName: "ردیف",
          valueGetter: "node.rowIndex + 1",
          width: 80,
        },
        {
          field: "patientInfo.name",
          headerName: "نام و نام خانوادگی",
          width: 175,
        },
        {
          headerName: "وضعیت",
          width: 100,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`identifierType_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x?.data?.patientInfo?.identifierType === "NATIONAL_CODE"
                  ? "ایرانی"
                  : "اتباع"}{" "}
              </Typography>
            );
          },
        },
        {
          headerName: "جنسیت",
          width: 120,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return x.data.patientInfo.sex === "MALE" ? (
              <Box
                key={`sex_${x.id}`}
                display="flex"
                justifyContent={isMobile ? "end" : "unset"}
                alignItems={"center"}
              >
                <MaleIcon size="0.5" />
                <Typography fontFamily="Vazirmatn">{"مرد"}</Typography>
              </Box>
            ) : (
              <Box
                key={`sex_${x.id}`}
                display="flex"
                justifyContent={isMobile ? "end" : "unset"}
                alignItems={"center"}
              >
                <FemaleIcon size="0.5" />
                <Typography fontFamily="Vazirmatn">{"زن"}</Typography>
              </Box>
            );
          },
        },
        {
          field: "patientInfo.identifier",
          headerName: " کد ملی / اتباع",
          width: 130,
        },
        {
          field: "patientInfo.phone",
          headerName: "شماره تلفن",
          width: 150,
        },
        {
          field: "patientInfo.fatherName",
          headerName: "نام پدر",
          width: 120,
        },
        {
          headerName: "بیمه",
          width: 150,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`insurance_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x?.data?.patientInfo?.insurance === "TAKMIL"
                  ? "تکمیلی"
                  : x?.data?.patientInfo?.insurance === "MILITARY"
                    ? "نیروهای مسلح"
                    : x?.data?.patientInfo?.insurance === "TAMIN"
                      ? "تامین اجتماعی"
                      : x?.data?.patientInfo?.insurance === "SALAMAT"
                        ? "سلامت"
                        : "ندارد "}{" "}
              </Typography>
            );
          },
        },
        {
          headerName: "وضعیت سنی",
          width: 130,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`age_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x?.data?.patientInfo?.ageType === "ADULT"
                  ? "بزرگسال"
                  : "کودک"}{" "}
              </Typography>
            );
          },
        },
        {
          headerName: "تاریخ تولد",
          width: 150,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`birthDate_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x.data.patientInfo.birthDate.split("-", 2)[0]}
              </Typography>
            );
          },
        },

        {
          field: "patientInfo.job",
          headerName: "شغل",
          width: 150,
        },
        {
          field: "patientInfo.patientNo",
          headerName: "شماره پرونده",
          width: 130,
        },
        {
          headerName: "عملیات",
          width: 140,
          cellRenderer: (x, options = {}) => {
            const isMobile = options.mobile ?? false;
            return (
              <Box
                key={`op_${x.id}`}
                display="flex"
                gap="10px"
                alignItems="center"
                justifyContent={isMobile ? "end" : ""}
              >
                <IconButton
                  width={"80px"}
                  height="40px"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowEditModal(true);
                    setDataRowEdit(x.data.patientInfo);
                  }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  width={"80px"}
                  height="40px"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    setDeleteModal(true);
                    setDataRowDelete(x.data.patientInfo);
                  }}
                >
                  <TrashIcon />
                </IconButton>
              </Box>
            );
          },
        },
      ],
    ],
    [],
  );

  return (
    <>
      <DeleteAlertModal
        handleDelete={handleDelete}
        open={deleteModal}
        setOpen={setDeleteModal}
      />

      <CustomTable
        refetching={refetching}
        onPageChange={(pageIndex, pageSize) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: pageSize,
          });
        }}
        pageSize={pageable.pageSize}
        totalElements={totalElements}
        currentPage={pageable.pageIndex}
        rowData={rowData}
        columns={colDefs}
      />
    </>
  );
}
